var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "b-field",
        { attrs: { grouped: "" } },
        [
          _c(
            "b-field",
            { attrs: { label: "Height", "label-position": "on-border" } },
            [
              _c("b-input", {
                model: {
                  value: _vm.canvasHeightInput,
                  callback: function ($$v) {
                    _vm.canvasHeightInput = $$v
                  },
                  expression: "canvasHeightInput",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-field",
            {
              attrs: {
                label: "Mode",
                "label-position": "on-border",
                expanded: "",
              },
            },
            [
              _c(
                "b-select",
                {
                  model: {
                    value: _vm.mode,
                    callback: function ($$v) {
                      _vm.mode = $$v
                    },
                    expression: "mode",
                  },
                },
                [
                  _c("option", { attrs: { value: "pen" } }, [
                    _vm._v(_vm._s(_vm.$t("common.pen"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "eraser" } }, [
                    _vm._v(_vm._s(_vm.$t("common.eraser"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-field", [
            _c("button", { staticClass: "button", on: { click: _vm.undo } }, [
              _vm._v(_vm._s(_vm.$t("common.undo"))),
            ]),
          ]),
          _vm._v(" "),
          _c("b-field", [
            _c("button", { staticClass: "button", on: { click: _vm.redo } }, [
              _vm._v(_vm._s(_vm.$t("common.redo"))),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isActiveSaveButton
        ? _c("b-field", { attrs: { grouped: "", "group-multiline": "" } }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                { staticClass: "button", on: { click: _vm.saveImage } },
                [_vm._v("Save")]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  on: {
                    click: function ($event) {
                      _vm.savedImageData = ""
                    },
                  },
                },
                [_vm._v("Delete")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.savedImageData
        ? _c("div", [_c("img", { attrs: { src: _vm.savedImageData } })])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "paintContainer", attrs: { id: "paintContainer" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }